<div class="card">
    <ng-content
        *ngIf="!card_title; else header"
        select="[card-header]"></ng-content>
    <ng-template #header>
        <div class="card-header d-flex align-items-center">
            <h3 class="h4">{{ card_title }}</h3>
        </div>
    </ng-template>

    <div class="card-body">
        <ng-content></ng-content>
    </div>
</div>
